import { CancelToken } from 'axios'
import {
	ApiPostNoToken
} from 'shared/api'
import {
  registerApi
} from 'interface/endpoints'
import {
	ValidateFormData,
	ValidateResult,
	RegisterFormData,
  RegisterResult
} from './types'

export * from './types'

export const PostValidate = (
	domain: string,
	validateCode: string,
	form: ValidateFormData,
	cancelToken?: CancelToken
) => ApiPostNoToken<ValidateResult>(
	registerApi(domain, `/validate/${validateCode}`),
	form,
	cancelToken
)

export const PostRegister = (
	domain: string,
	form: RegisterFormData,
	cancelToken?: CancelToken
) => ApiPostNoToken<RegisterResult>(
	registerApi(domain),
	form,
	cancelToken
)
